<template lang="pug">
b-modal#rejectApprovedTicket(
  ref="rejectApprovedTicket"
  :title='$t("ui.combine.reject_approved_ticket")'
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover
        thead.thead-light
          tr
            th(colspan="2")
              span {{ $t("ui.withdrawal") }}
        tbody
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.affiliate") }}
            td
              span {{ ticketDetail.account_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.recipient_bank_id }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.recipient_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.recipient_bank_acc_holder }}
          tr(v-if="['ARS','AUD'].includes(getCurrencyCode)")
            td
              span {{ ['AUD'].includes(getCurrencyCode) ? $t("ui.bsb") : $t("ui.cuit") }}
            td
              span {{ ticketDetail.target_bank_acc_remark }}
          tr(v-if="['AUD'].includes(getCurrencyCode)")
            td
              span {{ $t("ui.payid") }}
            td
              span {{ ticketDetail.target_bank_acc_remark_2 }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
          tr
            td
              span {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr
            td
              span {{ $t("ui.modified_date") }}
            td
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
    b-form-group(:label="$t('ui.resubmit_ticket')").mb-2
      div.d-flex
        label.custom-switch
          input.custom-switch-input(type="checkbox" v-model="resubmit_ticket")
          span.custom-switch-indicator
    b-form-group(:label="$t('ui.remark')").mb-0
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.remark.$dirty"
        :error="$v.remark.$error"
        v-model.trim.lazy="$v.remark.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    div(slot="modal-footer")
      SubmitButton.float-right(icon="fa fa-ban" :text="$t('ui.reject')" @click="rejectApprovedTicket()" size="sm" variant="danger")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required, minLength, maxLength, url, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      resubmit_ticket: false,
      remark: '',
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  validations: {
    remark: {
      required
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.resubmit_ticket = false;
      this.remark = '';
      this.getTicketDetail();
    },
    getTicketDetail: function() {
      let url = config.ticketDetailAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    rejectApprovedTicket: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmRejectApprovedTicket();
      }
    },
    confirmRejectApprovedTicket: function() {
      let url = config.ticketRejectApprovedWithdrawalAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        resubmit_ticket: this.resubmit_ticket,
        remark: this.remark,
        ticket_id: this.ticketDetail.id,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.rejectApprovedTicket.hide();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$refs.rejectApprovedTicket.hide();
    },
  }
};
</script>
